export default (key: string): string => {
  return useRuntimeConfig().public[key];
};
